import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';
import CKEditField from '../../../../_common/platform/tsx/CKEditField';
import { IFormatChooserValue } from '../FormatChooser';
import { TEMPLATE_VALUE_KEY } from '../../ts/ConfigurationConstants';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');

interface ITemplateHelpOptions extends IPopupOptions {
    value: IFormatChooserValue;
    popupPriority?: number;
}

function TemplateHelp(props: { zIndex: number; options: ITemplateHelpOptions; close(): void; glob: IGlob }) {
    const globalClickIndex = React.useRef(0);

    React.useEffect(() => {
        if (props.options.popupPriority != null) {
            globalClickIndex.current = reactGlobalClick.register(props.close, props.options.popupPriority);
        } else {
            globalClickIndex.current = reactGlobalClick.register(props.close, 0);
        }

        return () => {
            reactGlobalClick.unregister(globalClickIndex.current);
            globalClickIndex.current = null;
        };
    }, []);

    const handleOnContainerClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const howToUseText = (
        <div>
            <p>{ 'Use can use Mustashe Templating or JS Templating.' }</p>
            <p>{ `Value to show can be specified by ID or Attribute Label or '${ TEMPLATE_VALUE_KEY }' for the current cell value.` }</p>
            <p>{ `For example, if 'URL' is ID or Label, a template for a URL could be` }</p>
            <p>
                <b>{ 'In Mustashe' }</b>
                <br />
                { `{{URL}}#tabs/1/workspaces{{${ TEMPLATE_VALUE_KEY }}}` }
            </p>
            <p>
                <b>{ 'In JS Templating' }</b>
                <br />
                { `<%URL%>#tabs/1/workspaces<%${ TEMPLATE_VALUE_KEY }%>` }
            </p>
            <p>
                <b>{ 'Transposed Grid notes' }</b>
                <br />
                { 'For transposed Grid, the pivot values are collected in the pivotValueArray.' }
                <br />
                { ' Each element of this array is JSON object with attribute IDs used as keys' }
                <br />
                { 'Thus, the tempate for PivotColumn shoud contain Mustache loop like' }
                <br />
                { '{{#pivotValueArray}} .... {{/pivotValueArray}}' }
            </p>
        </div>
    );

    return (
        <div
            className="popover bs-popover-right"
            style={ {
                display: 'block',
                left: props.options.left + 'px',
                top: props.options.top + 'px',
                maxWidth: '50rem',
                zIndex: props.zIndex
            } }
            onClick={ handleOnContainerClick }
        >
            <div className="arrow"></div>
            <h3 className="popover-header">
                { 'Template usage' }
                <button type="button" className="close" onClick={ props.close }>
                    ×
                </button>
            </h3>
            <div className="popover-body templateUsage-popover-content">{ howToUseText }</div>
        </div>
    );
}

export default function TemplateEditor(props: {
    editorConfig;
    template;
    formatChooserValue: IFormatChooserValue;
    glob: IGlob;

    onTemplateChange(value): void;
    onTemplateResize?(value): void;
}) {
    const showTemplateHelp = (e) => {
        const offset = $(e.target).offset();

        props.glob.DialogActions.createPopup<ITemplateHelpOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: props.formatChooserValue,
            component: TemplateHelp
        });
    };

    return (
        <div className="popover-content">
            <button type="button" className="btn btn-default" onClick={ showTemplateHelp }>
                { 'How to use' }
            </button>

            <CKEditField
                { ...props.editorConfig }
                value={ props.template }
                fillContainer={ true }
                dialogOffsetTop={ 100 }
                /* size={{
                    width: 500,
                    height: 400
                }}*/
                glob={ props.glob }
                onChange={ props.onTemplateChange }
                onResize={ props.onTemplateResize }
            />
        </div>
    );
}
